// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"f11c93a1","64":"75bea1f9","120":"d153f5da","219":"eff4366e","237":"e919a91a","338":"b65c8350","637":"1c76e625","654":"6016c963","928":"56d9ab42","936":"dfac056d","953":"19c234b7"}[chunkId] + ".chunk.js";
};